export default __webpack_public_path__ + "static/media/dog9.d32a29fc.JPG";